import type { z } from 'zod'
import { bigDecimalTextSchema } from '../utils/schemas'
import { assetBalanceSchema } from './assetBalance'

export const assetBorrowSchema = assetBalanceSchema.extend({
  borrowedAmount: bigDecimalTextSchema,
  borrowedValue: bigDecimalTextSchema,
})

export type AssetBorrow = z.infer<typeof assetBorrowSchema>
